module.exports = __webpack_public_path__ + "static/media/IN_Payslip_5.f29ec568.png";